/* Painel Admin — Piloto de Descontos Personalizados — Printar */
(function () {
  'use strict';

  const API = '/apps/printar/discount-incentivos/settings.php';
  const root = document.getElementById('dia-root');
  if (!root) return;

  const FIELDS = [
    { key: 'min_views', label: 'Nº mínimo de vistas', hint: 'vistas repetidas do mesmo produto para disparar o desconto' },
    { key: 'janela_dias', label: 'Janela (dias)', hint: 'período em que essas vistas contam' },
    { key: 'margem_minima_pct', label: 'Markup mínimo sobre o custo (%)', hint: 'nunca vender abaixo de cost_price × (1 + isto), em termos líquidos de IVA' },
    { key: 'teto_desconto_pct', label: 'Teto de desconto global (%)', hint: 'usado para fornecedores sem teto próprio definido abaixo' },
    { key: 'validade_dias', label: 'Validade do código (dias)', hint: 'quantos dias depois de gerado o código expira' },
    { key: 'cadencia_dias', label: 'Cadência entre códigos (dias)', hint: 'mínimo entre 2 códigos ao mesmo cliente' },
    { key: 'iva_pct', label: 'Taxa de IVA (%)', hint: 'usada para converter o preço (com IVA) para termos líquidos' },
    { key: 'views_intencao_alta', label: 'Vistas = intenção alta', hint: 'a partir daqui, o cliente já está quase a comprar sozinho → desconto mínimo' },
    { key: 'intensidade_min_pct', label: 'Desconto mínimo com intenção alta (% do teto)', hint: 'ex: 40 = usa só 40% do teto quando a intenção já é alta; sobe até 100% perto do mínimo de vistas' },
    { key: 'min_horas_entre_vistas', label: 'Horas mínimas entre 1ª e última vista', hint: 'anti-abuso: 5 vistas em 10min é reload/bot, não interesse real' },
    { key: 'controlo_pct', label: 'Grupo de controlo (%)', hint: 'esta % dos sinais elegíveis fica sem código, para medir conversão orgânica vs. com desconto' },
    { key: 'stock_baixo_limite', label: 'Stock considerado baixo (unidades)', hint: 'só mostra "restam X" no email se o stock real for igual ou menos que isto' },
    { key: 'max_produtos_por_email', label: 'Máx. produtos por email', hint: 'quando há vários produtos elegíveis, o email destaca o mais visto e o código cobre até este nº' },
    { key: 'atraso_minimo_horas', label: 'Atraso mínimo até contactar (horas)', hint: 'nunca enviar antes disto desde a última vista — evita "vi às 14h, recebi às 14:05"' },
  ];

  function toast(msg, type = 'success') {
    const wrap = document.querySelector('.dia-toasts');
    const t = document.createElement('div');
    t.className = `dia-toast dia-toast--${type}`;
    t.textContent = msg;
    wrap.appendChild(t);
    setTimeout(() => t.remove(), 4000);
  }

  async function api(method = 'GET', body = null) {
    const opts = { method, headers: { 'Content-Type': 'application/json' } };
    if (body) opts.body = JSON.stringify(body);
    const res = await fetch(API, opts);
    const json = await res.json();
    if (!res.ok) throw new Error(json.error || 'Erro na API');
    return json;
  }

  function render(settings, stats, fornecedores, tetosFornecedor, clientesAdmin, clientesB2c) {
    const fieldsHtml = FIELDS.map(f => `
      <div class="dia-field">
        <label for="dia-${f.key}">${f.label}</label>
        <input type="number" step="any" id="dia-${f.key}" value="${settings[f.key]}">
        <small>${f.hint}</small>
      </div>
    `).join('');

    const fornecedoresHtml = fornecedores.map(f => {
      const atual = tetosFornecedor[f.fornecedor];
      const placeholder = `usa o global (${settings.teto_desconto_pct}%)`;
      return `
        <div class="dia-field">
          <label for="dia-teto-${cssId(f.fornecedor)}">${f.fornecedor} <small>(${f.produtos} produtos)</small></label>
          <input type="number" step="any" placeholder="${placeholder}" data-fornecedor="${f.fornecedor}" id="dia-teto-${cssId(f.fornecedor)}" value="${atual != null ? atual : ''}">
        </div>
      `;
    }).join('');

    root.innerHTML = `
      <div class="dia-header">
        <h1>Piloto — Descontos Personalizados</h1>
        <label class="dia-switch">
          <input type="checkbox" id="dia-ativo" ${settings.ativo === '1' ? 'checked' : ''}>
          Ativo
        </label>
      </div>

      <div class="dia-stats">
        <div class="dia-stat"><strong>${stats.total_gerados || 0}</strong><span>Códigos gerados</span></div>
        <div class="dia-stat"><strong>${stats.total_usados || 0}</strong><span>Usados</span></div>
        <div class="dia-stat"><strong>${stats.ultimo_gerado ? new Date(stats.ultimo_gerado).toLocaleDateString('pt-PT') : '—'}</strong><span>Último gerado</span></div>
      </div>

      <div class="dia-field">
        <label class="dia-switch" style="justify-content:flex-start;gap:1rem">
          <input type="checkbox" id="dia-permitir-b2b" ${settings.permitir_b2b === '1' ? 'checked' : ''}>
          Permitir clientes B2B
        </label>
        <small>Desligado: clientes B2B nunca geram desconto, mesmo que tenham outras tags (ex: admin).</small>
      </div>

      <div class="dia-field">
        <label for="dia-modo-piloto">Modo do piloto</label>
        <select id="dia-modo-piloto" style="padding:1rem 1.2rem;border:1px solid #ddd;border-radius:.6rem;font-size:1.5rem">
          <option value="admin" ${settings.modo_piloto === 'admin' ? 'selected' : ''}>Admin — só a tag "${settings.tag_piloto}" (${clientesAdmin} clientes)</option>
          <option value="b2c" ${settings.modo_piloto === 'b2c' ? 'selected' : ''}>B2C — todos exceto B2B (${clientesB2c} clientes)</option>
        </select>
        <small>⚠️ Mudar para B2C abre o desconto a clientes reais, não só à equipa.</small>
      </div>

      <div class="dia-form">${fieldsHtml}</div>

      <h2 style="font-size:1.6rem;margin:2.8rem 0 .8rem">Teto de desconto por fornecedor</h2>
      <p style="font-size:1.2rem;opacity:.6;margin:0 0 1.2rem">Deixa em branco para usar o teto global. A margem real varia por fornecedor — este valor nunca ultrapassa o que a margem permite, só pode ser mais apertado.</p>
      <div class="dia-form">${fornecedoresHtml}</div>

      <div class="dia-actions">
        <button id="dia-save">Guardar definições</button>
      </div>
    `;

    document.getElementById('dia-save').addEventListener('click', () => save(fornecedores));
  }

  function cssId(s) { return s.replace(/[^a-z0-9]/gi, '-'); }

  async function save(fornecedores) {
    const btn = document.getElementById('dia-save');
    btn.disabled = true;
    try {
      const payload = {
        ativo: document.getElementById('dia-ativo').checked ? '1' : '0',
        modo_piloto: document.getElementById('dia-modo-piloto').value,
        permitir_b2b: document.getElementById('dia-permitir-b2b').checked ? '1' : '0',
      };
      FIELDS.forEach(f => { payload[f.key] = document.getElementById(`dia-${f.key}`).value; });

      const tetos_fornecedor = {};
      fornecedores.forEach(f => {
        const el = document.getElementById(`dia-teto-${cssId(f.fornecedor)}`);
        if (el && el.value !== '') tetos_fornecedor[f.fornecedor] = el.value;
      });
      payload.tetos_fornecedor = tetos_fornecedor;

      await api('POST', payload);
      toast('Definições gravadas.');
      await load();
    } catch (e) {
      toast(e.message, 'error');
    } finally {
      btn.disabled = false;
    }
  }

  async function load() {
    const { settings, stats, fornecedores, tetos_fornecedor, clientes_admin, clientes_b2c } = await api('GET');
    render(settings, stats, fornecedores, tetos_fornecedor, clientes_admin, clientes_b2c);
  }

  load().catch(e => { root.innerHTML = `<p style="text-align:center;opacity:.6">${e.message}</p>`; });
})();
